import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Image } from '../../../../models/index';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-show-item-details-modal-base',
  templateUrl: './show-item-details-modal-base.component.html',
  styleUrls: ['./show-item-details-modal-base.component.scss']
})

export class ShowItemDetailsModalBaseComponent implements OnInit {
  public name: string;
  public job: string;
  public cta: string;
  public link: string;
  public description: string;
  public image: Image;

  constructor(
    public dialogRef: MatDialogRef<ShowItemDetailsModalBaseComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Inject(DOCUMENT) private document: any
  ) {
    dialogRef.afterClosed().subscribe(result => {
      this.document.body.classList.remove('no-scroll');
    });
  }

  ngOnInit(): void {
    this.name = this.dialogData.name;
    this.job = this.dialogData.job;
    this.description = this.dialogData.description;
    this.image = this.dialogData.image;
    this.link = this.dialogData.link;
    this.cta = this.dialogData.cta ? this.dialogData.cta : 'buttons.close_window';
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-item-details-modal-base/show-item-details-modal-base.component.ts